// CONSTANTS are all caps.
const NS = 'EcommerceBlock';
const CLS = 'ecommerceBlock';
const WG = '.' + CLS + '-';

import utils from '../utils';

export class EcommerceBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.initProductItem();
	}

	initProductItem() {
		utils.initProductItemWidget(this.$element);
	}
}
